<section class="card page">
  <div class="page__head">
    <span class="kicker">How it works</span>
  </div>

  <div class="how-step">
  <div class="step-title">What we buy:</div>

  <p>
    We are buying singles as well as sealed products (booster boxes, display, etc.)
    of the trading card game One Piece TCG (eng. version).<br>
    You can sell us all quantities, from single cards to entire collections.<br>
    Rarities from super rares, Promos, Special Cards and higher.<br>
    We will also look at slabs (PSA, BGS, CGC) on a case-by-case basis.<br>
    <strong>We will pay 80–100% of the lowest Cardmarket price!</strong>
  </p>

  <!-- IMAGE PLACEHOLDERS -->
  <div class="what-we-buy-images">
    <div class="image-tile">
      <img src="assets/sr.png" alt="Single Card">
    </div>
    <div class="image-tile">
      <img src="assets/aa.png" alt="Single Card">
    </div>
    <div class="image-tile">
      <img src="assets/manga.png" alt="Single Card">
    </div>
  </div>
</div>

  <div class="hr"></div>
  <div class="how-step">
  <app-download-tutorial></app-download-tutorial>
  </div>
  <div class="hr"></div>
  <div class="how-step">
    <div class="step-title">Step 2: Fill out the sheet.</div>
    <app-how-it-works-tutorial></app-how-it-works-tutorial>
  </div>

  <div class="hr"></div>

  <div class="how-step">
    <div class="step-title">Step 3: Upload the sheet <a class="download-link" routerLink="/">here</a>.</div>
  </div>

  <div class="hr"></div>

  <div class="how-step">
    <div class="step-title">Step 4: Receive an offer.</div>
    After processing your submission, you will receive an email with an offer based on the data you provided.
  </div>

  <div class="hr"></div>

  <div class="how-step">
    <div class="step-title">Step 5.1: Accept the offer.</div>
    If you accept the offer as is, simply reply to the email confirming your acceptance. We will then provide you with further instructions on how to proceed with the transaction.
    You will need to ship the cards to us at your own cost. Once we receive and verify the cards, we will process the payment.
  </div>

  <div class="hr"></div>

  <div class="how-step">
    <div class="step-title">Step 5.2: Decline the offer.</div>
    If you choose to decline the offer, simply reply to the email indicating your decision. No further action is required on your part, and there are no penalties or fees for declining the offer.
  </div>

  <div class="next">

    <a class="btn" routerLink="/">Back to main page</a>
  </div>
</section>
